import './LoggedAgent.scss'

import PropTypes from 'prop-types'
import React from 'react'

export default function LoggedAgent({ agentName }) {
  return <div className="logged-agent">{agentName}</div>
}

LoggedAgent.propTypes = {
  agentName: PropTypes.string.isRequired
}
